import { render, staticRenderFns } from "./WidgetLoader.vue?vue&type=template&id=0e5cbefa&scoped=true&lang=html"
import script from "./WidgetLoader.vue?vue&type=script&lang=js"
export * from "./WidgetLoader.vue?vue&type=script&lang=js"
import style0 from "./WidgetLoader.vue?vue&type=style&index=0&id=0e5cbefa&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5cbefa",
  null
  
)

export default component.exports